import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Item, Wrapper } from './Navigation.styled';

export const Navigation = ({ items, selectedIndex = null, onClick = () => {}, horizontalLimit = 3 }) => (
  <Wrapper data-test="navigation">
    {items.map(({ id, value }, index) => {
      const onItemClick = () => onClick(index);
      return (
        <Item key={id} selected={index === selectedIndex} horizontalLimit={horizontalLimit} onClick={onItemClick} tabindex="0" role="button">
          {value}
        </Item>
      );
    })}
  </Wrapper>
);

export default memo(Navigation);

Navigation.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedIndex: PropTypes.number,
  onClick: PropTypes.func,
  horizontalLimit: PropTypes.number,
};
